<template>
    <div>
        <div class="departmentBox">
            <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
                <template slot="menuLeft" slot-scope="{size}">
                    <el-button  :size="size" class="View">新建部门</el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button  class="View">编辑</el-button>
                    <el-button  class="View">删除</el-button>
                </template>
            </avue-crud>
        </div>
    </div>
</template>

<script>
    export default {
        name: "department",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [
                    {
                        name:'总管理员',
                        time:'2022.10.15 14:15:25'

                    }, {
                        name:'子管理员',
                        time:'2022.10.12 01:15:30'
                    }
                ],
                option:{
                    addBtn:false,
                    align:'center',  // 表格列齐方式
                    menuAlign:'center', // 菜单栏对齐方式
                    editBtn: false, // 行内编辑按钮
                    delBtn: false, //行内删除按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    refreshBtn: false, //刷新按钮
                    stripe:true,
                    column:[
                        {
                            label:'部门名称',
                            prop:'name',

                        }, {
                            label:'创建时间',
                            prop:'time',
                        }
                    ]
                },
            };
        },
        methods:{
            changePage(num){
                console.log(num)
            }
        }
    }
</script>

<style scoped>
    .departmentBox{
        padding: 30px;
        background-color: #fff;
        margin: 10px;
        border-radius: 5px;
    }
    .View{
        background-color: #3b63f6;
        color: #fff;
    }
    /deep/.el-card__body{
        text-align: center;
    }
</style>
